import { TransportationTrackingActionType } from '../../transportation-tracking';
import { TransportMode } from '../../../common/constants';
import { MapStop } from '../../../common/models';
import { MAP_ITEM_STYLES } from './tracking-map.constants';
import { MapCoordinates } from './tracking-map-base.model';

export class MapPolyline implements google.maps.PolylineOptions {
  strokeWeight = MAP_ITEM_STYLES.strokeWeight;
  zIndex = 1;
  strokeColor = MAP_ITEM_STYLES.stopPathColor;
  path: MapCoordinates[] = [];

  constructor(startMarker?: MapStop, endMarker?: MapStop) {
    if (startMarker) {
      this.path.push(new MapCoordinates(startMarker));

      if (endMarker) {
        this.path.push(new MapCoordinates(endMarker));
        this.strokeColor =
          startMarker.isPassed && endMarker.isPassed
            ? MAP_ITEM_STYLES.stopPathColorPassed
            : MAP_ITEM_STYLES.stopPathColor;
      }
    }
  }
}

export class StopMarkerOptions implements google.maps.MarkerOptions {
  position: MapCoordinates;
  icon: google.maps.Icon;

  constructor(params?: MapStop, transportMode?: TransportMode) {
    if (params) {
      const url: string = this.getIconUrl(params, transportMode);

      this.position = new MapCoordinates(params);
      this.icon = {
        url,
        anchor: new google.maps.Point(22, 65),
        scaledSize: {
          height: 72,
          width: 44,
          // just interface implementation
          equals(_other: google.maps.Size | null): boolean {
            return true;
          },
        },
      };
    }
  }

  getIconUrl(params?: MapStop, transportMode?: TransportMode): string {
    let url: string;
    const portActions = (params.actions || []).filter(
      (action: TransportationTrackingActionType) =>
        action === TransportationTrackingActionType.PortOfDischarge ||
        action === TransportationTrackingActionType.PortOfLoading,
    );
    if (portActions.length) {
      url = `assets/core/icons/pin_port_${transportMode.toLowerCase()}${params.isPassed ? '_processed' : ''}.svg`;
    } else {
      url = `assets/core/icons/pin_${(params.actions || []).join('-').toLowerCase()}${
        params.isPassed ? '_processed' : ''
      }.svg`;
    }
    return url;
  }
}
